import React from 'react'
import './header.css'

import headerImg from '../../assets/main-screen.png'
import headerImgFull from '../../assets/main-screen-full.png'

const header = () => {
  return (
    <div>
      <div className="header__content">
        <div className="header__text">
          <h1>Monitor your business on real-time dashboard</h1>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Elementum nisi aliquet
            volutpat pellentesque volutpat est. Sapien in etiam vitae nibh nunc mattis
            imperdiet sed nullam.
          </p>
          <p><a href="#pricing" className="rounded__btn">Try for free</a></p>
        </div>

        <img src={headerImgFull} alt="" className="header__img" />
      </div>
    </div>
  )
}

export default header
